var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"archived",on:{"click":function($event){return _vm.$emit('exit')}}},[_c('ArrowIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }